import {createReducer, on} from '@ngrx/store';
import {borrarEmpresa, cargarEmpresa} from '../actions/empresa.actions';
import {Empresa} from "../models/empresa.model";
export {Empresa} from '../models/empresa.model';

const initialState: Empresa | null = null;

const _empresaReducer = createReducer(
  initialState,
  on(cargarEmpresa, (state, nuevaEmpresa) => {
    // Si el estado es null (al inicio), simplemente devuelve el nuevo objeto
    if (!state) {
      return nuevaEmpresa;
    }
    // Si el estado ya existe, fusiona el estado actual con el nuevo payload
    return {
      ...state,
      ...nuevaEmpresa
    };
  }),
  on(borrarEmpresa, (state) => null),
);

export function empresaReducer(state: Empresa | null, action: any) {
  return _empresaReducer(state, action);
}
